import Vue from 'vue'
import SearchBanner from '@/components/SearchBanner.vue'

if (document.querySelector("#app-search-banner") !== null) {
  new Vue({
    components: {
      SearchBanner
    }
  }).$mount('#app-search-banner')
}
